import React, { useState } from "react";
import { IComment } from "@Interfaces/Entities/Poll";
import { CommentsWrapper } from "./PollitemComments.styled";
import CommentItem from "./CommentItem";

interface IStateComment {
    count: number;
    list: IComment[];
    isLoading: boolean;
    isExpanded: boolean;
    loadMore: boolean;
}

interface IPollItemComment {
    pollId: string;
    channelId: string;
    commentsList: IStateComment;
}

const PollItemComments: React.FC<IPollItemComment> = ({
    channelId,
    commentsList,
}) => {
    const [activeComment, setActiveComment] = useState(null);

    const showComments = (comments: IComment[]) =>
        comments.map((comment: IComment) => (
            <CommentItem
                key={comment._id}
                commentData={comment}
                channelId={channelId}
                activeComment={activeComment}
                setActiveComment={setActiveComment}
            />
        ));

    return <CommentsWrapper>{showComments(commentsList.list)}</CommentsWrapper>;
};

export default PollItemComments;
